import $ from "jquery";
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class ArticleSorters extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;
        if (!Context.IsLogged()) {
            this.props.history.push("/login");
            return;
        }

        var sid = Context.GetContext().Sid;
        var articles = Comm.GetArticleSorters({ session: sid });
        var sorters = Comm.GetSorters({ session: sid });
        var permissions = Comm.Permissions(sid);

        this.state = {
            Articles: articles,
            Sorters: sorters,
            Permissions: permissions,
            SelectedArticle: null,
        };

        this.Save = this.Save.bind(this);
    }

    ShowArticle(article) {
        this.setState({ SelectedArticle: article });
    }

    Save() {
        var sid = Context.GetContext().Sid;

        var sorters = [];
        $("input[id^='cbSorter']:checked").each(function (i, e) {
            var val = $(e).attr("permvalue");
            sorters.push({ id: val });
        });
        var data = {
            session: sid,
            articles: JSON.stringify({ id: this.state.SelectedArticle.id, sorters: sorters }),
        };
        Comm.SaveArticleSorters(data);

        this.setState({
            Articles: Comm.GetArticleSorters({ session: sid }),
            SelectedArticle: null,
        });
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }
        if (Context.RenderNotOK(this.props.history)) return null;

        return Context.HasRight("rarticlesorters") === true ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("sorter2good")}</div>
                <div className="panel-body">
                    <br />
                    <div className="row">
                        <div className="col-md-5">
                            {this.state.Articles.map((obj) => (
                                <p
                                    className={
                                        this.state.SelectedArticle !== null &&
                                        this.state.SelectedArticle.id === obj.id
                                            ? "btn btn-warning"
                                            : null
                                    }
                                >
                                    <a onClick={() => this.ShowArticle(obj)} className="pointhand">
                                        {obj.name}
                                    </a>
                                </p>
                            ))}
                        </div>
                        <div className="col-md-7">
                            {this.state.SelectedArticle !== null ? (
                                <div id="dData" className="borderDiv">
                                    <div className="row">
                                        <div className="col-md-12">
                                            {Context.HasRight("earticlesorters") === true ? (
                                                <button
                                                    className="btn btn-primary pull-right"
                                                    onClick={this.Save}
                                                >
                                                    {Translation.Trans("save")}
                                                </button>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="row scrollableDiv">
                                        <div className="col-md-6">
                                            {this.state.Sorters.map((obj) =>
                                                obj.visible ? (
                                                    <div className="checkbox">
                                                        <input
                                                            id={"cbSorter" + obj.id}
                                                            type="checkbox"
                                                            permvalue={obj.id}
                                                            key={obj.id + "_" + this.state.SelectedArticle.id}
                                                            defaultChecked={this.state.SelectedArticle.hasOwnProperty(
                                                                "o" + obj.id
                                                            )}
                                                        />
                                                        <label for={"cbSorter" + obj.id}>{obj.name}</label>
                                                    </div>
                                                ) : null
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default ArticleSorters;



// WEBPACK FOOTER //
// ./src/pages/articlesorters.js